import { render, staticRenderFns } from "./IzipayForm.vue?vue&type=template&id=01b31c99&scoped=true&"
import script from "./IzipayForm.vue?vue&type=script&lang=js&"
export * from "./IzipayForm.vue?vue&type=script&lang=js&"
import style0 from "./IzipayForm.vue?vue&type=style&index=0&id=01b31c99&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b31c99",
  null
  
)

export default component.exports